module.exports = __webpack_public_path__ + "images/double-feature-e473ac0f9228c9c48b93f979e671f45e.png";